<template>
  <nav class="nav-bar-mobile">
    <!-- <a class="nav-bar-mobile__logo">
      <icon data="@icon/logo.svg" original />
    </a> -->
    <button
      class="nav-bar-mobile__button"
      @click="() => (menuOpen = !menuOpen)"
    >
      <Transition name="fade">
        <icon data="@icon/hamburger.svg" v-if="!menuOpen" original />
        <icon data="@icon/close.svg" v-else original />
      </Transition>
    </button>
    <a
      class="nav-bar-mobile__download"
      :href="`${$baseUrl}pdf/${
        $tm('pages.home').find((el) => el.id === 'cta-section-0').content
          .pdfTitle
      }`"
      target="_blank"
      download
      ><icon data="@icon/download.svg"
    /></a>
    <Transition name="fade">
      <div class="nav-bar-mobile__menu" v-if="menuOpen">
        <LanguageSwitcher
          class="nav-bar-mobile__menu__language"
          :languages="$tm('pages.home[0].content.languages')"
        />
        <router-link
          v-for="(page, index) in pageLinks"
          class="nav-bar-mobile__menu__link"
          :key="page + '-' + index"
          :to="{ params: { page } }"
          @click.native="menuOpen = false"
          >{{ $t(`navigation.${page}`) }}</router-link
        >
      </div>
    </Transition>
  </nav>
</template>

<script setup>
import { ref } from "vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";

const menuOpen = ref(false);

defineProps({
  pageLinks: {
    type: Array,
    default: () => [],
  },
  languages: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="scss" scoped>
.nav-bar-mobile {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  height: var(--navbar-height-mobile);
  width: 100%;
  background-color: var(--white-100);
  border-bottom: 1px solid var(--scala-grigi-gray-2);
  padding: 0 toRem(16);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__logo {
    width: toRem(41);
    height: toRem(33);

    & > svg {
      min-width: 100%;
      min-height: 100%;
    }
  }

  &__button {
    width: toRem(20);
    height: toRem(20);
    // transform: translateX(toRem(-10));
    position: relative;

    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      min-width: 100%;
      min-height: 100%;
    }
  }

  &__download {
    width: toRem(24);
    height: toRem(24);

    & > svg {
      min-width: 100%;
      min-height: 100%;
    }
  }

  &__menu {
    position: fixed;
    top: var(--navbar-height-mobile);
    left: 0;
    display: flex;
    flex-direction: column;
    background-color: var(--white-100);
    width: 100%;
    height: calc(100% - var(--navbar-height-mobile));

    &__language {
      padding: toRem(30) 0;
      width: fit-content;
      align-self: center;
    }

    &__link {
      @include link-l;
      flex-grow: 1;
      border-top: 1px solid var(--scala-grigi-gray-2);
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;

      &:last-child {
        background-color: var(--black-100);
        color: var(--primary-yellow);
      }
    }
  }
}
</style>
